import {mapRecordToItems} from '@/helpers/mapRecordToItems.helper';

export enum ProductShipmentFields {
    ITEMS = 'items',
    PRODUCT_ORDER = 'productOrder',
    PRODUCT_SHIPMENT_BUNDLE = 'productShipmentBundle',
    QUANTITY = 'quantity',
    PACKAGE_MEASUREMENTS = 'packageMeasurements',
    RECIPIENT_NAME = 'recipientName',
    RECIPIENT_EMAIL = 'recipientEmail',
    RECIPIENT_ADDRESS = 'recipientAddress',
    SENDER_NAME = 'senderName',
    SENDER_EMAIL = 'senderEmail',
    SENDER_ADDRESS = 'senderAddress',
    SHIPMENT_TYPE = 'shipmentType',
    SHIPMENT_PROVIDER = 'shipmentProvider',
    SHIPMENT_PRODUCT_REF = 'shipmentProductRef',
    SHIPMENT_REF = 'shipmentRef',
    FILE = 'file',
    CREATED_AT = 'createdAt',
    UPDATED_AT = 'updatedAt',
}

export namespace ProductShipmentFields {
    type Data = { text: string; readonly?: true; updateOnly?: true; };

    export const Record: Record<ProductShipmentFields, Data> = {
        [ProductShipmentFields.ITEMS]: {
            text: 'Elemente',
        },
        [ProductShipmentFields.PRODUCT_ORDER]: {
            text: 'Produktbestellung',
        },
        [ProductShipmentFields.PRODUCT_SHIPMENT_BUNDLE]: {
            text: 'Versandpaket',
        },
        [ProductShipmentFields.QUANTITY]: {
            text: 'Menge',
        },
        [ProductShipmentFields.PACKAGE_MEASUREMENTS]: {
            text: 'Paketmaße',
        },
        [ProductShipmentFields.RECIPIENT_NAME]: {
            text: 'Empfängername',
        },
        [ProductShipmentFields.RECIPIENT_EMAIL]: {
            text: 'Empfänger-E-Mail',
        },
        [ProductShipmentFields.RECIPIENT_ADDRESS]: {
            text: 'Empfängeradresse',
        },
        [ProductShipmentFields.SENDER_NAME]: {
            text: 'Absendername',
        },
        [ProductShipmentFields.SENDER_EMAIL]: {
            text: 'Absender-E-Mail',
        },
        [ProductShipmentFields.SENDER_ADDRESS]: {
            text: 'Absenderadresse',
        },
        [ProductShipmentFields.SHIPMENT_TYPE]: {
            text: 'Versandart',
        },
        [ProductShipmentFields.SHIPMENT_PROVIDER]: {
            text: 'Versanddienstleister',
        },
        [ProductShipmentFields.SHIPMENT_PRODUCT_REF]: {
            text: 'Versandprodukt-Referenz',
        },
        [ProductShipmentFields.SHIPMENT_REF]: {
            text: 'Versandreferenz',
        },
        [ProductShipmentFields.FILE]: {
            text: 'Datei',
        },
        [ProductShipmentFields.CREATED_AT]: {
            text: 'Erstellt am',
        },
        [ProductShipmentFields.UPDATED_AT]: {
            text: 'Aktualisiert am',
        },
    }

    export const Items = mapRecordToItems(Record);
}
